import { GAME_VARIABLES } from "../../../constants";

export class Chunk4 {
  constructor(scene: Phaser.Scene) {
    const sprite1 = scene.add.sprite(
      0,
      GAME_VARIABLES.IS_RESTART ? 0 : -30,
      "atlas",
      "background_chunk4/gradient_backer"
    );

    if (!GAME_VARIABLES.IS_RESTART) {
      scene.add.tween({
        targets: sprite1,
        y: `+=30`,
        duration: 3000,
        ease: "Expo.easeOut",
      });
    }

    sprite1.setDepth(-2);
    sprite1.setActive(false);

    const particles = scene.add.particles("atlas");
    const rect = new Phaser.Geom.Rectangle(-10, 30, 128 + 10, 128 - 30);
    const emitter = particles.createEmitter({
      quantity: { min: 3, max: 4 },
      frame: Array.from(new Array(9)).map(
        (_, i) => `FX/pink_cloud/cloud${i + 1}`
      ),
      frequency: 3000,
      maxVelocityX: 2,
      maxVelocityY: 0,
      speed: [0.5, 0.7, 1],
      gravityY: 0,
      lifespan: 16000,
      emitZone: { type: "random", source: rect },
    });
    emitter.explode(20);
    emitter.frequency = 3000;
    emitter.setAlpha(function (
      p: Phaser.GameObjects.Particles.Particle,
      _k: number,
      t: number
    ) {
      return 1 - 2 * Math.abs(t - 0.5);
    });
  }
}
